class DetailsDisclosure extends HTMLElement {
  protected mainDetailsToggle: HTMLDetailsElement;
  protected content: HTMLElement;
  protected animations?: Animation[];

  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details') as HTMLDetailsElement;
    this.content = this.mainDetailsToggle.querySelector('summary')?.nextElementSibling as HTMLElement;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut(): void {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle(): void {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close(): void {
    this.mainDetailsToggle.removeAttribute('open');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) {
      summary.setAttribute('aria-expanded', 'false');
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  private header: HTMLElement | null;

  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle(): void {
    if (!this.header) return;
    (this.header as HTMLElement & { preventHide?: boolean }).preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    );
  }
}

customElements.define('header-menu', HeaderMenu);

export { DetailsDisclosure, HeaderMenu };
